import React from "react";
import { observer } from "mobx-react";
import { EventType } from "@gp/models";

import classNames from "classnames";
import { BetOffer } from "@models";

export default observer(function EventName(props: {
	offer: BetOffer;
	isDetails?: boolean;
}) {
	const nameClasses = classNames("bet__name bet__type__name", {
		"bet__name--multi": props.offer.isMulti,
		"bet__name--event":
			props.offer.sportData.eventType !== EventType.NORMAL,
		"bet__name--teams":
			!props.offer.isMulti &&
			props.offer.sportData.eventType === EventType.NORMAL,
		"bet__name--full": props.isDetails,
	});

	if (props.offer.isMulti) {
		return (
			<span className={nameClasses}>{props.offer.multiEventName}</span>
		);
	}

	if (props.offer.sportData.eventType !== EventType.NORMAL) {
		return (
			<span className={nameClasses}>
				{props.offer.sportData.eventName}
			</span>
		);
	}

	return (
		<span className={nameClasses}>
			{props.offer.multiOffers && props.offer.multiOffers.length > 0 && (
				<i className="u-icon u-icon--sml u-icon--bb--active u-mar--right--xtny" />
			)}
			{props.offer.teamOneString} - {props.offer.teamTwoString}
		</span>
	);
});
